import {v4 as uuid} from 'uuid';

class UniqueIdProvider {
  next() {
    return uuid()
  }
}

export {UniqueIdProvider}